import template from './sale-type-commercial.jade';
import saleType from '../../../enums/sale-type-commercial';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.saleTypeCommercial', [])
    .directive('cianAfPriceAndDealTermsSaleTypeCommercial', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.saleTypes = saleType;

            this.validation = validation(this.form, 'bargainTerms.saleType', {
                required: 'Укажите тип договора',
            });
        },
        controllerAs: 'saleTypeCommercial',
        template,
    }))
    .name;
